import request from '@/utils/request';

const endpoints = {
    categories: '/delivery/categories',
    certainCategory: '/delivery/category',
    allCategories: '/delivery/categories/all'
};

export default {
    getItems: ({ dispatch, commit }, params = {}) => {
        return request({
            url: endpoints.categories,
            method: 'GET',
            params,
        }).then(res => {
            if (res.data) {
                commit('PROCESS_RES', res.data);
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },
    raiseCategory: async ({ dispatch }, id) => {
        return request({
            url: `${endpoints.certainCategory}/${id}/raise`,
            method: 'PATCH',
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },
    lowerCategory: async ({ dispatch }, id) => {
        return request({
            url: `${endpoints.certainCategory}/${id}/lower`,
            method: 'PATCH',
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },
    getAllItems({ dispatch, commit, state }) {
        if (state.allItems.length > 0) {
            return;
        }

        return request({ url: endpoints.allCategories, method: 'GET' })
          .then(res => {
              if (res.data) {
                  commit('SET_ALL_ITEMS', res.data.items);
              }
          }).catch(error => {
              if (error.response && error.response.data && error.response.data.error) {
                  dispatch('alert/addMessage', {
                      message: error.response.data.error
                  }, {root: true});
              }
          });
    }
};
